import { BlockUI } from 'primeng/blockui';
import { RouterOutlet } from '@angular/router';
import { ChangeDetectionStrategy, Component, inject, OnInit, signal } from '@angular/core';

import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { AuthService } from '../../../core/services/auth.service';
import { RoleSelectionDialogComponent } from '../../components/role-selection-dialog/role-selection-dialog.component';

@Component({
	selector: 'app-main-layout',
	templateUrl: './main-layout.component.html',
	imports: [HeaderComponent, RouterOutlet, FooterComponent, RoleSelectionDialogComponent, BlockUI],
	styleUrls: ['./main-layout.component.css'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class MainLayoutComponent implements OnInit {
	public showRoleDialog = signal<boolean>(false);

	private readonly authService = inject(AuthService);

	ngOnInit(): void {
		this.checkIfShouldShowRoleDialog();
	}

	/**
	 * Checks if the role selection dialog should be shown
	 */
	private checkIfShouldShowRoleDialog(): void {
		const userRoles = this.authService.getRoles();
		const isDialogDisabled = localStorage.getItem('isShowSelectRoleDialog') === 'false';
		const roleDialogShown = localStorage.getItem('roleDialogShown') === 'true';

		if (userRoles.length > 1 && !isDialogDisabled && !roleDialogShown) {
			this.showRoleDialog.set(true);
			localStorage.setItem('roleDialogShown', 'true');
		}
	}

	/**
	 * Handles role dialog visibility change
	 */
	public onRoleDialogVisibilityChange(visible: boolean): void {
		this.showRoleDialog.set(visible);
	}
}
